import { render, staticRenderFns } from "./PagarPix.vue?vue&type=template&id=4a272234"
import script from "./PagarPix.vue?vue&type=script&lang=ts"
export * from "./PagarPix.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports